import { render, staticRenderFns } from "./childReturn.vue?vue&type=template&id=3c80f43a"
import script from "./childReturn.vue?vue&type=script&lang=js"
export * from "./childReturn.vue?vue&type=script&lang=js"
import style0 from "./childReturn.vue?vue&type=style&index=0&id=3c80f43a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports